<template>
  <div class="background">
    <div
      class="background__image"
      :style="{
        backgroundImage: `url(${$baseUrl}images/bg.png) `,
      }"
    ></div>

    <div :class="['background__lines']" :key="'lines'">
      <div
        class="background__lines--line"
        v-for="index in NLines"
        :key="index"
      ></div>
    </div>
    <div
      class="background--img"
      v-if="landingIndex == -1 || isMenuOpen || isModalOpen"
      :key="'main'"
      :style="{
        backgroundImage: 'var(--main-gradient)',
      }"
    />
    <transition name="fade">
      <div
        class="background--img"
        v-if="landingIndex >= 0 && !isMenuOpen && !isModalOpen"
        :key="backGroundColor"
        :style="{
          backgroundImage: backGroundColor,
        }"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import bgColor from "@/mixins/bgColor";
export default {
  name: "Background",
  mixins: [bgColor],
  computed: {
    NLines() {
      if (this.$tvaMq === "mobile") {
        return 2;
      } else {
        return 3;
      }
    },
    ...mapGetters({
      landingIndex: "scroller/landingIndex",
      _color: "ui/sourceColor",
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
    }),
  },
};
</script>

<style lang="scss" scoped>
.background {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;

  &__image {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  &__lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding-left: $header-width-mobile;
    padding-right: $header-width-mobile;

    &--line {
      height: 100vh;
      width: toRem(1);
      background-color: $white_02;
    }
  }

  &--img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    mix-blend-mode: multiply;
    transition: all 1s ease;
    background-size: 100vw;
  }
}

.tablet {
  .background {
    &__lines {
      justify-content: space-beetwen;
      padding: 0 25vw;
      &--line {
      }
    }
  }
}
</style>
